export const numBool = (value) => (value ? '1' : '0');
